import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ITEM_WIDTH = 280;
const GAP = 16;
const CarouselRoot = styled.div.withConfig({
  displayName: "Carousel__CarouselRoot"
})(["display:flex;align-items:center;gap:8px;contain:inline-size;"]);
const ScrollContainer = styled.div.withConfig({
  displayName: "Carousel__ScrollContainer"
})(["display:flex;gap:", "px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;scrollbar-width:none;min-width:0;&::-webkit-scrollbar{display:none;}"], GAP);
const CarouselItemWrapper = styled.div.withConfig({
  displayName: "Carousel__CarouselItemWrapper"
})(["flex:0 0 ", "px;scroll-snap-align:start;"], ITEM_WIDTH);
const NavButton = styled.button.withConfig({
  displayName: "Carousel__NavButton"
})(["flex-shrink:0;width:36px;height:36px;border-radius:4px;border:1px solid var(--trellis-color-border-core-subtle,var(--border-core-subtle,#ccc));background:var(--fill-surface-default);box-shadow:none;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;color:var(--text-core-default,#33475b);&:hover{background:var(--fill-surface-hover,#f5f8fa);}&:active{background:var(--fill-surface-pressed,#eaf0f6);}"]);
export function Carousel({
  'aria-label': ariaLabel,
  children
}) {
  const scrollRef = useRef(null);
  const [showButtons, setShowButtons] = useState(false);
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const ro = new ResizeObserver(() => {
      setShowButtons(el.scrollWidth > el.clientWidth);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return /*#__PURE__*/_jsxs(CarouselRoot, {
    role: "region",
    "aria-roledescription": "carousel",
    "aria-label": ariaLabel,
    children: [showButtons && /*#__PURE__*/_jsx(NavButton, {
      onClick: () => {
        var _scrollRef$current;
        return (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollBy({
          left: -(ITEM_WIDTH + GAP)
        });
      },
      "aria-label": "Previous",
      type: "button",
      children: /*#__PURE__*/_jsx(LeftIcon, {
        size: "100"
      })
    }), /*#__PURE__*/_jsx(ScrollContainer, {
      ref: scrollRef,
      children: children
    }), showButtons && /*#__PURE__*/_jsx(NavButton, {
      onClick: () => {
        var _scrollRef$current2;
        return (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 ? void 0 : _scrollRef$current2.scrollBy({
          left: ITEM_WIDTH + GAP
        });
      },
      "aria-label": "Next",
      type: "button",
      children: /*#__PURE__*/_jsx(RightIcon, {
        size: "100"
      })
    })]
  });
}
export function CarouselItem({
  children
}) {
  return /*#__PURE__*/_jsx(CarouselItemWrapper, {
    role: "group",
    "aria-roledescription": "slide",
    children: children
  });
}